import { render, staticRenderFns } from "./logisticsList.vue?vue&type=template&id=0a0774ec&scoped=true&"
import script from "./logisticsList.vue?vue&type=script&lang=js&"
export * from "./logisticsList.vue?vue&type=script&lang=js&"
import style0 from "./logisticsList.vue?vue&type=style&index=0&id=0a0774ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0774ec",
  null
  
)

export default component.exports